<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-insert-row`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M45 5a1 1 0 00-1-1H4a1 1 0 00-1 1v2a1 1 0 001 1h27.999v23H5a2 2 0 00-2 2v9a2 2 0 002 2h39a1 1 0 001-1V5zM7 35h33.999L41 40H7v-5zM41 8h-5l-.002 23h5.001L41 8zm-22.4 6.2a1 1 0 00-1.6.8v2H4a1 1 0 00-1 1v2a1 1 0 001 1h12.999L17 23a1 1 0 001.6.8l5.333-4a1 1 0 000-1.6l-5.333-4z"/></svg>
</template>
<script>

export default {
  name: 'IconInsertRow',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
